export default __webpack_public_path__ + "static/uxdesign_icon_1-0c524e502fb0e6a74096a2e68e122082.svg";